export type DriveItemId = number;

// directory — a folder or the Drive root
// container — a directory or a collection
// null is used for Drive root
export type DriveContainerId = DriveItemId | null;

// id for temp item created during optimistic update;
export function isTemporaryDriveItemId(id: DriveItemId) {
  return id < 0;
}
